export default __webpack_public_path__ + "static/media/openHighHat.f78d7be8.wav";